import { ConfigService } from '@finder/core/config.service';
const ɵ0 = (config) => {
    return {
        wdprConversationCookieName: config.getValue('convIdCookieName'),
        wdprConversationHeader: config.getValue('convIdHeaderName'),
        wdprCorrelationHeader: config.getValue('corrIdHeaderName'),
        wdprEndpointFilter: '/advanced-finder/error/?'
    };
};
export class CoreModule {
}
export { ɵ0 };
